import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './features171.css'

const Features171 = (props) => {
  return (
    <div className="features171-layout349 thq-section-padding">
      <div className="features171-max-width thq-section-max-width">
        {/* Replacing image with video */}
        <div className="features171-image-container">
          <video
            src={props.feature1VideoSrc ?? '/AI-youth-video.mp4'}
            title={props.feature1VideoTitle ?? 'AI Entrepreneurship Make-A-Thon Video'}
            className="features171-video"
            controls
            allowFullScreen
            style={{
              width: '100%',
              maxWidth: '640px',
              height: 'auto',
              maxHeight: '360px',
              objectFit: 'contain'
            }}
          >
            Your browser does not support the video tag.
          </video>
        </div>
        <div className="features171-content1">
          <div className="features171-section-title">
            <div className="features171-content2">
              <h2>
                {props.feature1Title ?? (
                  <Fragment>
                    <h2 className="features171-text3 thq-heading-2">
                      Simplilearn, AI Academy
                    </h2>
                  </Fragment>
                )}
              </h2>
              <p>
                {props.feature1Description ?? (
                  <Fragment>
                    <p className="features171-text4 thq-body-large">
                      Industry-level certification from Simplilearn for free for countries and we can provide the offerings to all staff as well. A total of 10000 slots are available and we have uptake. The collaboration is worth USD 5 million.
                    </p>
                  </Fragment>
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Features171.defaultProps = {
  feature1VideoSrc: '/video2.mp4',
  feature1VideoTitle: 'AI Entrepreneurship Make-A-Thon Video',
  feature1Title: undefined,
  feature1Description: undefined,
}

Features171.propTypes = {
  feature1VideoSrc: PropTypes.string,
  feature1VideoTitle: PropTypes.string,
  feature1Title: PropTypes.element,
  feature1Description: PropTypes.element,
}

export default Features171
